/**
 * custom-color-swatches.js
 * ------------------------------------------------------------
 * Conecta los botones de color propios con el input nativo
 * oculto de Shopify. Ademas actualiza al instante (sin esperar
 * al servidor) el texto "Color: X" y el borde del circulo
 * seleccionado, para que se vean sincronizados de inmediato.
 *
 * Soporta dos tipos de swatch:
 * - Nativos: existen como variante real de este producto (radio
 *   oculto data-option-name="Color"). Comportamiento sin cambios.
 * - Externos (data-external-color="true"): el color vive en el
 *   producto auxiliar "Colores Adicionales" (para no romper el
 *   limite de 250 variantes de Shopify). No hay radio nativo que
 *   marcar; en su lugar se dispara el evento personalizado
 *   'family:color-select' que escucha variant-smart-select.js
 *   para reconstruir la tabla de tallas y la imagen principal.
 * ------------------------------------------------------------
 */
(function () {
  if (window.__customColorSwatchesInit) return;
  window.__customColorSwatchesInit = true;

  document.addEventListener('click', function (event) {
    var button = event.target.closest('.custom-color-swatch');
    if (!button) return;

    var wrapper = button.closest('[data-custom-color-swatches]');
    if (!wrapper) return;

    var newColor = button.dataset.customColorValue;
    var isExternal = button.dataset.externalColor === 'true';

    // Actualiza al instante el texto "Color: X" y el borde seleccionado
    var label = wrapper.querySelector('[data-custom-color-selected]');
    if (label) label.textContent = newColor;

    wrapper.querySelectorAll('.custom-color-swatch').forEach(function (btn) {
      var isThis = btn === button;
      btn.classList.toggle('is-selected', isThis);
      btn.setAttribute('aria-pressed', isThis ? 'true' : 'false');
    });

    if (isExternal) {
      document.dispatchEvent(
        new CustomEvent('family:color-select', {
          detail: { color: newColor, external: true, wrapper: wrapper }
        })
      );
      return;
    }

    // Avisa que se volvio a un color nativo, por si veniamos de uno externo
    document.dispatchEvent(
      new CustomEvent('family:color-select', {
        detail: { color: newColor, external: false, wrapper: wrapper }
      })
    );

    // Conecta con el selector nativo oculto para que precio, tabla y carrito se actualicen
    var variantSelects = wrapper.nextElementSibling;
    while (variantSelects && variantSelects.tagName !== 'VARIANT-SELECTS') {
      variantSelects = variantSelects.nextElementSibling;
    }
    if (!variantSelects) {
      variantSelects = wrapper.parentElement.querySelector('variant-selects');
    }
    if (!variantSelects) return;

    var escapedValue = window.CSS && CSS.escape ? CSS.escape(newColor) : newColor;
    var radio = variantSelects.querySelector(
      'input[type="radio"][data-option-name="Color"][value="' + escapedValue + '"]'
    );
    if (!radio) return;

    if (!radio.checked) {
      radio.checked = true;
      radio.dispatchEvent(new Event('change', { bubbles: true }));
    }
  });
})();
